import React, { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  HeaderNavigation,
  HeaderPanel,
  HeaderNavigationMobile,
  ModalLogin,
  ModalSignup,
  ModalRecovery,
} from '@features';
import { CookiesPolicyPopup} from '@widgets';
import { ADMIN_URL, KEYMAKER_URL } from '@app/routes';
import {
  HEADER_NAVIGATION_LINKS,
  HEADER_NAVIGATION_LOGO_CUT,
} from './header_full.consts';
import {
  logoutTC,
  //getActiveSearch,
  getCustomer,
  getModalLoginShow,
  getModalSignupShow,
  getModalRecoveryShow,
} from '@entities';
import { SearchFormContext } from '@shared/hooks';

const HeaderFull = () => {
  const dispatch = useDispatch();
  const ref = useRef();
  //const searchValue = useSelector(getActiveSearch);
  const isModalLoginShow = useSelector(getModalLoginShow);
  const isModalSignupShow = useSelector(getModalSignupShow);
  const isModalRecoveryShow = useSelector(getModalRecoveryShow);
  const { pathname, search } = useLocation();
  const user = useSelector(getCustomer);

  //const IS_BROWSER_PAGE = pathname === BROWSE_URL.pathname;
  const IS_ADMIN_URL = pathname.includes(ADMIN_URL.pathname);
  //const IS_TECHWORKS_SHOW = localStorage.getItem('accept_tech_works') !== 'true';
  const IS_COOKIE_SHOW = 
    localStorage.getItem('accept_cookie') !== 'true' && 
    sessionStorage.getItem('decline_cookie') !== 'true';
  const FULL_PATH = `${pathname}${search}`;

  if (!IS_ADMIN_URL && !user.id) {
    localStorage.setItem('fullpath', FULL_PATH);
  }

  if (FULL_PATH.includes(KEYMAKER_URL.pathname)) {
    localStorage.removeItem('fullpath');
  }

  /*
   * GET initial data
   */
  const onChangeSearch = (event) => {
  };

  const onSubmitSearch = (event) => {
    event.preventDefault();
  };

  const logout = async () => {
    dispatch(logoutTC());
  };

  const DefaultHeader = (
    <div className="d-flex jc-sb header__wrapper">
      <SearchFormContext.Provider
        value={{
          onSubmitSearch,
          onChangeSearch,
          //searchValue,
        }}
      >
        <HeaderNavigationMobile headerLinks={HEADER_NAVIGATION_LOGO_CUT} />
      </SearchFormContext.Provider>

      <HeaderNavigation headerLinks={HEADER_NAVIGATION_LINKS} />

      <HeaderPanel logout={logout} />
    </div>
  );

  return (
    <>
      {/*IS_TECHWORKS_SHOW && <TechWorksPopup />*/}
      {IS_COOKIE_SHOW && <CookiesPolicyPopup />}
      <header className="header" ref={ref}>
        <div className="full__container">
          {DefaultHeader}
        </div>
      </header>
      {isModalLoginShow && <ModalLogin /> }
      {isModalSignupShow && <ModalSignup /> }
      {isModalRecoveryShow && <ModalRecovery /> }
    </>
  );
};

export default HeaderFull;
